import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@bookips/sds";
const ChannelHintBox = (param)=>{
    let { maskedPhone , maskedEmail  } = param;
    const label = maskedPhone ? "가입된 번호" : maskedEmail ? "카카오 메일" : null;
    const value = maskedPhone !== null && maskedPhone !== void 0 ? maskedPhone : maskedEmail;
    if (!label || !value) return null;
    return /*#__PURE__*/ _jsx("span", {
        className: "bg-gray-0 mt-3 block rounded-md px-5 py-3 md:-ml-9 md:w-[calc(100%+2.25rem)]",
        children: /*#__PURE__*/ _jsxs(Typography, {
            variant: "subtitle1",
            className: "text-primary",
            children: [
                /*#__PURE__*/ _jsxs("span", {
                    className: "whitespace-nowrap",
                    children: [
                        label,
                        " :"
                    ]
                }),
                " ",
                /*#__PURE__*/ _jsx("span", {
                    className: "break-all",
                    children: value
                })
            ]
        })
    });
};
export default ChannelHintBox;
